import { Injectable } from '@angular/core';
import { MediaHavenPlugin } from '../entities/mediahaven-plugins.entity';
import { PluginGuard } from './plugin.guard';

@Injectable({
    providedIn: 'root'
})
export class AdvancedMediaPlayerGuard extends PluginGuard {
    protected PLUGINS_TO_CHECK: MediaHavenPlugin[] = [MediaHavenPlugin.ADVANCED_MEDIA_PLAYER];
}
